<template>
  <div class="box1">
    <div class="boxOne">
      <div class="item dn-content-bg">
        <div class="left-content box theme-color">
          <div style="padding: 6px; background: #00388c; color: #fff">
            对象列表：
            <el-select style="width: 140px" size="mini" v-model="objId">
              <el-option v-for="(item, index) in tableData" :key="index" :value="item.id" :label="item.displayName"></el-option>
            </el-select>
          </div>
          <div>
            <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
          </div>
          <div class="tree-con">
            <el-tree :data="treeData" node-key="id" ref="tree" show-checkbox @check="checkTree" @node-click="treeClick" default-expand-all :check-strictly="true" :highlight-current="true" :expand-on-click-node="false" :filter-node-method="filterNode">
              <span class="custom-tree-node" slot-scope="{ data }" :disabled="true">
                <span class="node-label">{{ data.measureName }}</span>
                <span class="node-btn">
                </span>
              </span>
            </el-tree>
          </div>
        </div>
      </div>
      <div class="item dn-content-bg">
        <div class="topstyle1">
          <el-table id="table" class="table-content" ref="table" :stripe="true" :border="true" :data="expressData" :height="'500px'" @selection-change="handleSelectionChange" tooltip-effect="light">
            <el-table-column v-if="true" type="selection"></el-table-column>
            <template v-for="(item, index) in columns">
              <template v-if="item.show != false ">
                <slot v-if="item.slot" :name="item.slot"></slot>
                <el-table-column v-else :key="index" :prop="item.prop" :label="item.label" :align="item.align?item.align:'center'" :fixed="item.fixed?item.fixed:false" :width="item.width" :type="item.type?item.type:''" show-overflow-tooltip :sortable="item.sortable?item.sortable:false"></el-table-column>
              </template>
            </template>
            <slot></slot>
          </el-table>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" style="margin-left:300px">
      <el-button type="primary" @click="save" class="btn">保 存</el-button>
      <el-button @click="close(false)" class="cancel">取 消</el-button>
    </div>
  </div>
</template>
<script>
import api from "@common/api/index.js";
import tree from "@/utils/tree";
import NkTable from '@/components/common/NkTable'
export default {
  name: 'Bar',
  components: { NkTable },
  props: {
    kpiId: {
      type: String,
      default: ''
    },
    isClick: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      objId: "",
      tableData: [],
      filterText: "",
      treeData: [],
      expressData: [],
      isIndeterminate: true,
      express: [],
      checkAll: false,
      expressOne: [],
      columns: [
        {
          prop: 'name',
          label: '名称',
          show: true,
          align: 'center',
        },
        {
          prop: 'displayName',
          label: '显示名称',
          show: true,
          align: 'center'
        },
      ]
    }
  },
  created () {
    this.getCompanyViewTreesInfo()
  },
  watch: {
    objId (val) {
      let vm = this;
      vm.getViewTreeNodes(val);
    },
    /* 搜索节点 */
    filterText (val) {
      this.$refs.tree.filter(val);
    },
  },
  mounted () {

  },
  methods: {
    /* 获取对象列表 */
    getCompanyViewTreesInfo () {
      let vm = this;
      api.view.getCompanyViewTreesInfo(this.$store.state.user.currentCompanyId).then((res) => {
        if (res) {
          vm.tableData = res.data;
          if (res.data.length > 0) {
            vm.objId = res.data[0].id;
          }
        }
      });
    },
    /* 获取节点树 */
    getViewTreeNodes (id) {
      api.view.getViewTreeNodes(id).then((res) => {
        let item = this.tableData.find((obj) => obj.id === id);
        let templates = [];
        api.measure.getMeasureTemplates().then((obj) => {
          templates = obj.data;
        });
        item.templates = templates;
        this.objItem = item;
        let nodeData = [
          {
            id: 0,
            measureName: item ? item.displayName : "对象",
          },
        ];
        nodeData = nodeData.concat(res.data);
        this.nodeData = nodeData;
        console.log(res.data)
        let data = tree.creatTreeJson(res.data, 0);
        this.treeData = [
          {
            id: 0,
            measureName: item ? item.displayName : "对象",
            children: data,
            disabled: true,
          },
        ];
        //默认选中第一个子节点
        // if (data.length > 0) {
        //   this.selectedMeasure = data[0];
        //   this.$nextTick(function () {
        //     this.$refs["tree"].setCurrentKey([]);
        //     this.$refs.tree.setCheckedKeys([]);
        //   });
        // }
      });
    },
    /* 搜索树节点 */
    filterNode (value, data) {
      if (!value) return true;
      return data.measureName.indexOf(value) !== -1;
    },
    /* 树复选框点击 */
    async checkTree (node, checkNodes) {
      let [vm, measures] = [this, []];
      if (checkNodes.checkedNodes.length == 0) {
        /* 放右边表格勾选记录的 */
        vm.expressOne = [];
        /* 右边表格数据 */
        vm.expressData = [];
      }
      checkNodes.checkedNodes.map(item => {
        /* 有些节点是没有测量点的 */
        if (item.measureId) {
          measures.push(item.measureId);
          if (node.id == item.id) {
            vm.$refs["tree"].setCurrentKey(node.id);
          }
        }
      });
      console.log(node)
      console.log(checkNodes)
      if (measures.length <= 0) {
        return;
      }
      /* 获取表达式 */
      let res = await vm.$api.measure.getUniqueMeasuresExpressions(JSON.stringify(measures));
      if (!res.success) {
        return;
      }
      /* 放右边表格勾选记录的 */
      vm.expressOne = [];
      /* 右边表格数据 */
      vm.expressData = [];
      res.data.map((item, i) => {
        vm.expressOne.push({
          measureId: item.id,
          data: []
        });
        item.expressionGroups.map(k => {
          k.expression.map((temp, j) => {
            if (item.id == node.measureId) {
              vm.expressData.push(temp);
            }
            temp.measureId = item.id;
            vm.expressOne[vm.expressOne.length - 1].data.push(temp);
          });
        })

      })
      console.log(vm.expressData)
    },
    /* 树点击事件 */
    treeClick (data, node, obj) {
      let vm = this;
      let thisexpressItem = vm.expressOne.find(item => item.measureId == data.measureId);
      if (!thisexpressItem) {
        return;
      }
      /* 一开始清除所有选中状态 */
      vm.$refs.table.clearSelection();
      vm.expressData = JSON.parse(JSON.stringify(thisexpressItem.data));
      setTimeout(() => {
        /* 设置默认选中的条数 */
        vm.expressData.map(item => {
          if (item.selectFlag) {
            vm.$refs.table.toggleRowSelection(item, true);
          }
        })
      }, 0)
    },
    /* 表格勾选事件 */
    handleSelectionChange (val) {
      let vm = this;
      if (val.length <= 0) {
        return;
      }
      let thisTableItem = vm.expressOne.find(item => item.measureId == val[0].measureId);
      /* 一开始全都设置没选中状态 */
      thisTableItem.data.map(item => {
        item.selectFlag = false;
      });
      val.map(valItem => {
        /* 如果记录数据的里的id跟表格勾选的id相同则将该数据设置选中状态 */
        thisTableItem.data.map(item => {
          if (item.id == valItem.id) {
            item.selectFlag = true;
          }
        });
      });
    },
    /* 保存 */
    save () {
      let params = []
      this.expressOne.map(item => {
        item.data.map(temp => {
          if (temp.selectFlag) {
            params.push({
              measureId: temp.measureId,
              expressionName: temp.name
            })
          }

        })
      })
      this.$emit("saveUsing", params);
    },
    /* 取消 */
    close () {
      this.$emit("close", false);
    }
  }
}
</script>
<style lang="scss" scoped>
.box1 {
  width: 100%;
  height: 100%;
  .boxOne {
    text-align: left;
    width: 100%;
    height: 500px;
    display: flex;
    .item {
      display: flex;
      flex: 1;
      flex-flow: column;
      padding: 0 6px;
      box-sizing: border-box;
      .left-content {
        display: flex;
        flex-flow: column;
        overflow: hidden;
        display: flex;
        flex: 1;
        flex-flow: column;
        .tree-con {
          flex: 1;
          overflow: auto;
        }
      }
    }
  }
}

.topstyle1 {
  text-align: left;
  margin: 7px;
  display: flex;
  overflow: auto;
  flex-flow: column;
  flex: 1;
}
</style>